import React, { useContext } from "react";
import { MyContext } from "../State/ProviderData";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

const ChildEventStore = (props) => {
  const [myData] = useContext(MyContext);
  const { epreuve, addEvent, removeEvent } = props;
  const sendData = () => {
    addEvent(epreuve);
    alert(epreuve.name_event + " ajouté à votre liste !");
  };
  const handleRemove = () => {
    removeEvent(epreuve);
    alert(epreuve.name_event + " supprimé de votre liste.");
  };
  return (
    <div>
      <ul>
        <li
          key={epreuve.id}
          style={{ width: "20px" }}
          className="mx-auto d-block"
        >
          {myData
            .filter((e) => e != null)
            .find((item) => item.id === epreuve.id) ? (
            <DeleteForeverIcon
              className="mx-auto d-block bg-warning"
              onClick={handleRemove}
            />
          ) : null}
        </li>
        <li
          key={epreuve.name_event}
          style={{ width: "20px" }}
          className="m-auto"
        >
          {myData
            .filter((e) => e != null)
            .find((item) => item.id === epreuve.id) ? null : (
            <AddToPhotosIcon
              className="mx-auto d-block bg-primary"
              onClick={() => {
                sendData();
              }}
            />
          )}
        </li>
      </ul>
    </div>
  );
};

export default ChildEventStore;
